import { helpers, required, requiredIf } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";

const { locale } = await useLocale("validation");

export default {
  housingType: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  monthlyRent: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: string, { housingType }: any) {
        return housingType.value === 1;
      }),
    ),
    nonZero: helpers.withMessage(
      () => locale?.value?.zero_not_allowed ?? validationJson.zero_not_allowed,
      (value: string, { housingType }) => {
        return housingType.value === 1 ? Validator.nonZero(value) : true;
      },
    ),
  },
};
